import React, { Fragment } from "react";
import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../AbstractElements";
import { Col } from "react-bootstrap";
import TransactionHome from "./TransactionHome";

export default function TransactionList() {
    return (
        <Fragment>
            <Breadcrumbs mainTitle="List of Transactions" parent="Home" title="List of Transactions" />
            <Container fluid={true}>
                <Row>
                    <Col className="h-100">
                       <TransactionHome />
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}
